<template>
  <div class="col-12 g">
    <!-- Stats -->
    <div class="row mb-2">
      <div class="col-6 col-md-3 g">
        <div class="card card-body text-center">
          <h4 class="text-primary">{{ stats.totalChats }}</h4>
          <small>إجمالي المحادثات</small>
        </div>
      </div>
      <div class="col-6 col-md-3 g">
        <div class="card card-body text-center">
          <h4 class="text-success">{{ stats.todayChats }}</h4>
          <small>محادثات اليوم</small>
        </div>
      </div>
      <div class="col-6 col-md-3 g">
        <div class="card card-body text-center">
          <h4 class="text-info">{{ stats.totalMessages }}</h4>
          <small>إجمالي الرسائل</small>
        </div>
      </div>
      <div class="col-6 col-md-3 g">
        <div class="card card-body text-center">
          <h4 class="text-warning">{{ stats.uniqueUsers }}</h4>
          <small>عملاء فريدون</small>
        </div>
      </div>
    </div>

    <!-- Search -->
    <div class="card card-body mb-2">
      <div class="row">
        <div class="col-md-6">
          <input type="text" class="form-control" v-model="q" @input="searchChats" placeholder="ابحث بالاسم أو الهاتف أو الرسالة...">
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Chat List -->
      <div class="col-md-5 g">
        <div class="card card-body" style="max-height:600px;overflow-y:auto;">
          <img :src="require('@/assets/images/loading.svg')" alt="" width="50" v-if="loading" class="mx-auto">
          <div v-if="!loading && chats.length === 0" class="text-center text-muted py-3">لا توجد محادثات</div>
          <div v-for="chat in chats" :key="chat._id"
               class="border rounded p-2 mb-2"
               :class="selectedChat && selectedChat._id === chat._id ? 'border-primary bg-light-primary' : ''"
               style="cursor:pointer"
               @click="viewChat(chat._id)">
            <div class="d-flex justify-content-between">
              <div>
                <strong>{{ chat.user_name || 'بدون اسم' }}</strong>
                <div class="text-muted" style="font-size:12px">{{ chat.user_phone }}</div>
              </div>
              <div class="text-end">
                <span class="badge bg-primary rounded-pill">{{ chat.messages ? chat.messages.length : 0 }}</span>
                <div class="text-muted" style="font-size:11px">{{ chat.date }}</div>
              </div>
            </div>
            <div class="text-muted mt-1" style="font-size:12px" v-if="chat.last_message">
              <i class="fa fa-comment"></i> {{ chat.last_message.substring(0, 60) }}
            </div>
          </div>
          <!-- Pagination -->
          <div class="text-center mt-2" v-if="totalPages > 1">
            <button v-for="p in totalPages" :key="p"
                    class="btn btn-sm mx-1"
                    :class="p === page ? 'btn-primary' : 'btn-outline-primary'"
                    @click="loadChats(p)">{{ p }}</button>
          </div>
        </div>
      </div>

      <!-- Chat Viewer -->
      <div class="col-md-7 g">
        <div class="card">
          <div class="card-header">
            <h5 class="m-0" v-if="selectedChat">
              <i class="fa fa-user text-primary"></i>
              {{ selectedChat.user_name || 'بدون اسم' }}
              <small class="text-muted">{{ selectedChat.user_phone }}</small>
              <small class="text-muted">- {{ selectedChat.date }}</small>
              <button class="btn btn-sm btn-outline-danger float-start" @click="deleteChat(selectedChat._id)">
                <i class="fa fa-trash"></i>
              </button>
            </h5>
            <h6 class="m-0 text-muted" v-else>
              <i class="fa fa-comments"></i> اختر محادثة لعرضها
            </h6>
          </div>
          <div class="card-body" style="max-height:480px;overflow-y:auto;background:#f8f8fb;" ref="chatBody">
            <div v-if="!selectedChat" class="text-center text-muted py-5">
              <i class="fa fa-comment-dots fa-3x mb-3 d-block" style="opacity:0.2"></i>
              اختر محادثة من القائمة
            </div>
            <div v-else>
              <div v-for="(msg, i) in selectedChat.messages" :key="i"
                   class="d-flex mb-2" :class="msg.role === 'user' ? '' : 'justify-content-end'">
                <div class="ai-chat-bubble" :class="msg.role === 'user' ? 'ai-user' : 'ai-bot'">
                  <div v-if="msg.audio" class="mb-1">
                    <div class="d-flex align-items-center gap-2 mb-1" style="font-size:12px;opacity:0.8;">
                      <i class="fa fa-microphone"></i> رسالة صوتية
                    </div>
                    <audio controls style="max-width:100%;height:32px;" :src="'data:audio/webm;base64,' + msg.audio"></audio>
                  </div>
                  <div v-html="formatMsg(msg.content)"></div>
                  <div v-if="msg.action === 'navigate' && msg.route" class="ai-nav-badge mt-1">
                    <i class="fa fa-arrow-left"></i> تم التحويل إلى: <strong>{{ msg.route }}</strong>
                  </div>
                  <div class="ai-chat-time">
                    {{ formatTime(msg.time) }}
                    <span v-if="msg.role === 'assistant'" class="ms-2">
                      <span v-if="msg.action === 'navigate'" class="badge bg-success" style="font-size:10px">تحويل</span>
                      <span v-else class="badge bg-secondary" style="font-size:10px">رد</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      chats: [],
      selectedChat: null,
      stats: { totalChats: 0, todayChats: 0, totalMessages: 0, uniqueUsers: 0 },
      q: '',
      page: 1,
      totalPages: 1,
      searchTimer: null
    }
  },
  created() {
    this.loadStats()
    this.loadChats()
  },
  methods: {
    loadStats() {
      var g = this
      $.post(api + '/admin/ai-chats/stats', {
        jwt: localStorage.getItem('jwt')
      }).then(function(r) {
        if (r.status === 100) g.stats = r.response
      })
    },
    loadChats(page) {
      var g = this
      g.page = page || 1
      g.loading = true
      $.post(api + '/admin/ai-chats/list', {
        jwt: localStorage.getItem('jwt'),
        page: g.page,
        perpage: 30,
        q: g.q
      }).then(function(r) {
        g.loading = false
        if (r.status === 100) {
          g.chats = r.response
          g.totalPages = Math.ceil(r.total / 30)
        }
      }).fail(function() {
        g.loading = false
      })
    },
    searchChats() {
      var g = this
      clearTimeout(g.searchTimer)
      g.searchTimer = setTimeout(function() { g.loadChats(1) }, 400)
    },
    viewChat(id) {
      var g = this
      $.post(api + '/admin/ai-chats/view', {
        jwt: localStorage.getItem('jwt'),
        id: id
      }).then(function(r) {
        if (r.status === 100) {
          g.selectedChat = r.response
          g.$nextTick(function() {
            if (g.$refs.chatBody) {
              g.$refs.chatBody.scrollTop = g.$refs.chatBody.scrollHeight
            }
          })
        }
      })
    },
    deleteChat(id) {
      if (!confirm('حذف هذه المحادثة؟')) return
      var g = this
      $.post(api + '/admin/ai-chats/delete', {
        jwt: localStorage.getItem('jwt'),
        id: id
      }).then(function(r) {
        if (r.status === 100) {
          g.selectedChat = null
          g.loadChats(g.page)
          g.loadStats()
        }
      })
    },
    formatMsg(text) {
      if (!text) return ''
      var s = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      s = s.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank">$1</a>')
      s = s.replace(/\n/g, '<br>')
      return s
    },
    formatTime(t) {
      if (!t) return ''
      try {
        return new Date(t).toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })
      } catch(e) { return '' }
    }
  }
}
</script>

<style scoped>
.ai-chat-bubble {
  max-width: 80%;
  padding: 10px 16px;
  border-radius: 14px;
  font-size: 13.5px;
  line-height: 1.7;
  word-wrap: break-word;
}
.ai-user {
  background: linear-gradient(135deg, #7367f0, #9e95f5);
  color: #fff;
  border-bottom-right-radius: 4px;
}
.ai-bot {
  background: #fff;
  color: #333;
  border: 1px solid #e8e8ed;
  border-bottom-left-radius: 4px;
}
.ai-chat-time {
  font-size: 11px;
  opacity: 0.6;
  margin-top: 4px;
}
.ai-nav-badge {
  font-size: 11px;
  background: rgba(40, 199, 111, 0.15);
  color: #28c76f;
  padding: 4px 10px;
  border-radius: 8px;
  direction: rtl;
}
</style>
